import { SVGProps } from "react";

export const CompassMarkBrandV2 = ({
    width = "100%",
    height = "100%"
}: Pick<SVGProps<SVGSVGElement>, "height" | "width">) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="Container">
            <path
                id="Vector"
                d="M16.0147 16.2023V22.2978H10.0057V16.2023H16.0147V10.1104H5.0528C4.91239 10.1113 4.77357 10.1401 4.6444 10.1951C4.51523 10.2502 4.39828 10.3303 4.30035 10.4309C4.20241 10.5315 4.12545 10.6506 4.07393 10.7812C4.02241 10.9118 3.99735 11.0514 4.00022 11.1918V27.3408C3.99735 27.4812 4.02241 27.6208 4.07393 27.7514C4.12545 27.882 4.20241 28.001 4.30035 28.1017C4.39828 28.2023 4.51523 28.2824 4.6444 28.3375C4.77357 28.3925 4.91239 28.4213 5.0528 28.4222H20.9568C21.0972 28.4213 21.236 28.3925 21.3651 28.3375C21.4943 28.2824 21.6113 28.2023 21.7092 28.1017C21.8071 28.001 21.8841 27.882 21.9356 27.7514C21.9871 27.6208 22.0122 27.4812 22.0093 27.3408V16.2023H16.0147Z"
                fill="#1868DB"
            />
            <path
                id="Vector_2"
                d="M16.0137 4.01442V10.11H22.0371V16.2019H28.0282V5.08141C28.031 4.94103 28.006 4.80149 27.9544 4.67087C27.9029 4.54026 27.826 4.42119 27.728 4.32057C27.6301 4.21996 27.5131 4.13981 27.384 4.08478C27.2548 4.02974 27.116 4.00093 26.9756 4L16.0137 4.01442Z"
                fill="#1868DB"
            />
        </g>
    </svg>
);
